'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'space-station-moon-construction';
var width = 512;
var height = 512;
var aliases = ["space-station-moon-alt"];
var unicode = 'e034';
var svgPathData = ['M0 256c0 10.8 .7 21.4 2 31.9 72.4 25.2 159.6 40.1 254 40.1s181.6-14.9 254-40.1c1.3-10.5 2-21.1 2-31.9 0-6-.2-12-.6-17.9-.6-8.1-7.4-14.1-15.5-14.1L464 224c-8.8 0-16-7.2-16-16l0-32c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16-7.2 16-16l0-16.2C416 59 413.8 54.4 409.9 51.4 367.1 19.1 313.8 0 256 0 114.6 0 0 114.6 0 256zm15 86.5c35.5 98.8 130 169.5 241 169.5 74.3 0 141.2-31.6 187.9-82.2 2.6-2.9 4.1-6.6 4.1-10.5l0-3.3c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16-7.2-16-16l0-17c-40.9 5.9-83.9 9-128 9-87 0-169.2-12-241-33.5zM272 160a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z', 'M160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM256 328c-94.4 0-181.6-14.9-254-40.1 2.4 18.9 6.8 37.2 13 54.6 71.8 21.4 154 33.5 241 33.5s169.2-12 241-33.5c6.3-17.4 10.7-35.7 13-54.6-72.4 25.2-159.6 40.1-254 40.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpaceStationMoonConstruction = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;